// extracted by mini-css-extract-plugin
export default {"container":"AdminPageLayout_container__mdR6B","content":"AdminPageLayout_content__JT39k"};